var awsmobile = {
    stage: {
        aws_project_region: "us-west-2",
        aws_cognito_region: "us-west-2",
        aws_user_pools_id: "us-west-2_2uFSR45gn",
        aws_user_pools_web_client_id: "qid1gbfq2t2hdve09da9duvhi",
        aws_cognito_identity_pool_id: "us-west-2:e630ae3c-dade-4d78-a35f-16e47cc79b8a",
        aws_appsync_graphqlEndpoint: "https://75bv7hv33jdx5mfou57txtrh3a.appsync-api.us-west-2.amazonaws.com/graphql",
        aws_appsync_region: "us-west-2",
        aws_appsync_authenticationType: "OPENID_CONNECT",
        Auth: {
            mandatorySignIn: false,
            region: "us-west-2",
            userPoolId: "us-west-2_2uFSR45gn",
            userPoolWebClientId: "qid1gbfq2t2hdve09da9duvhi",
            identityPoolId: "us-west-2:e630ae3c-dade-4d78-a35f-16e47cc79b8a",
        },
        API: {
            endpoints: [
                {
                    name: "backend",
                    endpoint: "https://ptu9ucxm6i.execute-api.us-west-2.amazonaws.com",
                    region: "us-west-2",
                },
            ],
        },
    },
    prod: {
        aws_project_region: "us-west-2",
        aws_cognito_region: "us-west-2",
        aws_user_pools_id: "us-west-2_dmRlY79Ve",
        aws_user_pools_web_client_id: "5u6grlinb6o68p0bojrtj34pqc",
        aws_cognito_identity_pool_id: "us-west-2:997ba33a-5c9c-481d-afcf-c6d6586e5f1b",
        Auth: {
            mandatorySignIn: false,
            region: "us-west-2",
            userPoolId: "us-west-2_dmRlY79Ve",
            userPoolWebClientId: "5u6grlinb6o68p0bojrtj34pqc",
            identityPoolId: "us-west-2:997ba33a-5c9c-481d-afcf-c6d6586e5f1b",
        },
        API: {
            endpoints: [
                {
                    name: "backend",
                    endpoint: "https://96kvun2cz8.execute-api.us-west-2.amazonaws.com",
                    region: "us-west-2",
                },
            ],
        },
    },
};
export default awsmobile;
